export const clientInfoAdapter = (preorderData) => {
	const info = preorderData?.purchase_detail?.info || {};
	return [
		{
			email: info?.email || preorderData?.user_email || '-',
			name: (info?.first_name || '-') + ' ' + (info?.last_name || '-'),
			phone: info?.phone || '-',
			rut: info?.rut || '-',
		},
	];
};
